// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { string, array } from 'prop-types';
import { NavLink } from 'react-router-dom';

const StyledNWTabsNavigation = styled.div`
  display: flex;
  background: linear-gradient(90deg, #040F2A 0%, #041B54 100%);
  min-height: 3rem;
  margin: 15px 0;
  padding: 0 15px;

  .tabsNavigationItem {
    background-color: transparent;
    color: #fff;
    display: inline-flex;
    justify-content: center;
    margin-left: 1rem;
    margin-top: .1875rem;
    max-height: 2.82rem;
    padding: 1rem;

    &.active {
      background-color: #fff;
      color: #223f64;
    }
  }

  @media screen and (max-width: 1366px) {
    overflow-x: scroll;
    max-width: calc(100vw - 30px);

    .tabsNavigationItem {
      white-space: nowrap;
    }
  }
`;

const NWTabsNavigation = ({ className, links, ...rest }) => {
  if (!links || !links.length) return null;

  return (
    <StyledNWTabsNavigation className={ `tabsNavigation ${ className }` } { ...rest }>
      { links.map(link => (
        <NavLink
          to={ link.to }
          end={ link.end }
          key={ link.to }
          className={ ({ isActive }) => `tabsNavigationItem ${ isActive ? ' active' : '' }` }
        >
          { link.label }
        </NavLink>
      )) }
    </StyledNWTabsNavigation>
  );
};

NWTabsNavigation.propTypes = {
  className: string,
  links: array
};

export { NWTabsNavigation };
